import { useEffect } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { useDispatch } from 'react-redux'
import { PrefillResumeEvents } from 'builder/modules/constants'
import { useI18n } from 'builder/hooks/useI18n'
import {
  actions,
  AutoTailoringFromPublicJobBoardMode,
  AutoTailoringFromPublicJobBoardStep,
} from 'builder/modules/resumeEditor'
import {
  OptionsContainer,
  CloseIconWrapper,
  CloseIcon,
  Title,
  Header,
  Line,
  HeaderLineContainer,
} from './styles'

import OptionCards from './OptionCards'
import { Props } from './types'

export const AutotaloringView = ({ onClose: onCloseFillResumeModal }: Props) => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const createResume = () => {
    dispatch(
      actions.setAutoTailoringForPublicJobBoard({
        step: AutoTailoringFromPublicJobBoardStep.step1,
        mode: AutoTailoringFromPublicJobBoardMode.createResume,
        enableAutoTailoringButton: true,
      }),
    )

    onCloseFillResumeModal()
  }

  const linkedinResume = () => {
    dispatch(
      actions.setAutoTailoringForPublicJobBoard({
        step: AutoTailoringFromPublicJobBoardStep.step1,
        mode: AutoTailoringFromPublicJobBoardMode.reviewResume,
        enableAutoTailoringButton: true,
      }),
    )

    onCloseFillResumeModal()
  }

  useEffect(() => {
    trackInternalEvent(PrefillResumeEvents.seeStartScreen)
  }, [])

  const onStartScreenClose = () => {
    trackInternalEvent(PrefillResumeEvents.clickCrossButtonStartScreen)
    createResume()
  }

  return (
    <OptionsContainer>
      <HeaderLineContainer>
        <Line />
        <Header>
          <Title>{i18n.t('builder.prefill_resume.auto_tailoring_view.title')}</Title>
          <CloseIconWrapper onClick={onStartScreenClose}>
            <CloseIcon />
          </CloseIconWrapper>
        </Header>
      </HeaderLineContainer>
      <OptionCards {...{ createResume, linkedinResume, onCloseFillResumeModal }} />
    </OptionsContainer>
  )
}
